import request from '@/router/axios'
import env from '@/config/env'

/**
 * 获取城际订单列表
 * @param params
 */
export const queryAllLowLine = () => {
  return request({
    url: env.ferryUrl + '/merchantPriceAdmin/queryAllLowLine',
    method: 'GET'
  })
}

/**
 * 获取城际订单列表
 * @param params
 */
export const list = (params) => {
  return request({
    url: env.ferryUrl + '/c-order/page',
    method: 'post',
    data: params
  })
}

/**
 * 获取订单详情
 * @param id
 */
export const details = (id) => {
  return request({
    url: env.ferryUrl + `/c-order/detail?id=${id}`,
    method: 'get'
  })
}
/**
 * 获取订单详情
 * @param id
 */
export const newDetails = (id) => {
  return request({
    // url: env.ferryUrl + `/c-order/detail?id=${id}`,
    url: env.ferryUrl + `/c-order/detailNew?id=${id}`,
    method: 'get'
  })
}

/**
 * 设置备注或者电话
 * @param params
 */
export const setMbOrMk = (params) => {
  return request({
    url: env.ferryUrl + '/c-order/setMsg',
    method: 'post',
    params
  })
}

/**
 * 退款详情
 * @param id
 */
export const refundDetail = (id) => {
  return request({
    url: env.ferryUrl + `/c-order/refundDetail?orderId=${id}`,
    method: 'get'
  })
}

/**
 * 退款
 * @param data
 */
export const refundSub = (data) => {
  return request({
    url: env.ferryUrl + '/c-order/submitRefund',
    method: 'POST',
    data
  })
}

/**
 * 取消中央订票
 * @param id
 */
export const cancelCenter = (id) => {
  return request({
    url: env.ferryUrl + `/c-order/cancel?id=${id}`,
    method: 'get'
  })
}
/**
 * 获取支付二维码
 * @param id
 */
export const getpayQRcode = (id) => {
  return request({
    url: env.ferryUrl + `/c-order/getPayQrcode?orderId=${id}`,
    method: 'GET'
  })
}

// 异常改签-跨供应商
export const changeTicket = (data) => {
  return request({
    url: env.ferryUrl + '/c-order/changeBossCustomOrderMoreMerchant',
    method: 'post',
    data
  })
}

export const check = (data) => {
  return request({
    url: env.ferryUrl + '/c-order/checkIschange',
    method: 'post',
    data
  })
}

export const getDriverAndCarInfo = () => {
  return request({
    url: env.ferryUrl + '/c-order/queryMerchantDriverAndCarInfo',
    method: 'post'
  })
}

export const getFlightTime = (lineId) => {
  return request({
    url: env.ferryUrl + '/c-order/queryFightPlan',
    method: 'GET',
    params: {
      lineId
    }
  })
}
export const getFlightTime2 = (data) => {
  return request({
    url: env.ferryUrl + '/c-order/queryFightPlanV2',
    method: 'POST',
    data,
    header: {
      'Content-Type': 'application/json'
    }
  })
}
export const queryList = (data) => {
  return request({
    url: env.ferryUrl + '/c-order/pageNew',
    method: 'post',
    timeout: 30000,
    data
  })
}

export const queryListNew = (data) => {
  return request({
    url: env.ferryUrl + '/c-order/v2/page',
    method: 'post',
    data
  })
}

/**
 * 查询交易详情
 * @param payNo
 * @param flag
 */
export const queryTransactionDetail = (payNo, flag) => {
  return request({
    url: env.ferryUrl + `/c-order/queryTransactionDetail?payNo=${payNo}&&flag=${flag}`,
    method: 'GET'
  })
}

/**
 * 三方退款
 * @param params
 */
export const thirdRefund = (params) => {
  return request({
    url: env.ferryUrl + '/api-boss/c-order/thirdRefund',
    method: 'POST',
    data: params
  })
}

/**
 * 查询该供应商或指定供应商绑定的线路
 * @param params
 */
export const queryMerchantLine = (data) => {
  return request({
    url: env.ferryUrl + '/merchantPriceAdmin/queryMerchantLine?',
    method: 'GET',
    params: data
  })
}

// 同程订单取消
export const cancelOrder = (params) => {
  return request({
    url: env.ferryUrl + '/tc-order/cancel-order',
    method: 'post',
    data: params
  })
}

// 发送行程单
export const sendItinerary = (data) => {
  return request({
    url: env.ferryUrl + '/orderAdmin/sendItinerary/v2',
    method: 'post',
    data
  })
}

// 获取行程单信息
export const getOrderItineraryMsg = (params) => {
  return request({
    url: env.ferryUrl + '/orderAdmin/getOrderItineraryMsg',
    method: 'get',
    params
  })
}

// 获取订单最早一次时间(包含所有的改签单)
export const orderMaxTime = (orderId) => {
  return request({
    url: env.ferryUrl + `/c-order/getOrderMaxTime/${orderId}`,
    method: 'GET'
  })
}

// 检查是否可以改签
export const checkRebook = (orderId) => {
  return request({
    url: env.ferryUrl + `/c-order/checkRebook/${orderId}`,
    method: 'GET'
  })
}
